// 配送希望日・配送時間帯の選択をカート属性に保存する
(function() {
  'use strict';

  // カート属性を更新する関数
  function updateCartAttributes(deliveryDate, deliveryTimeslot) {
    // 配送日の指定フラグを決定
    const hasDeliveryDateSpecified = deliveryDate && deliveryDate !== '' && deliveryDate !== '指定なし';
    const deliveryDateSpecification = hasDeliveryDateSpecified ? 'あり' : 'なし';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          '配送日の指定': deliveryDateSpecification,
          '配送希望日': deliveryDate || '',
          '配送時間帯': deliveryTimeslot || ''
        }
      })
    });
  }

  // カートページの処理
  function initCartPage() {
    const deliveryDateSelect = document.querySelector('#delivery_date');
    const deliveryTimeslotSelect = document.querySelector('#delivery_timeslot');
    
    if (!deliveryDateSelect || !deliveryTimeslotSelect) {
      return;
    }

    // セレクトボックス変更時の処理
    function handleChange() {
      updateCartAttributes(deliveryDateSelect.value, deliveryTimeslotSelect.value);
    }

    deliveryDateSelect.addEventListener('change', handleChange);
    deliveryTimeslotSelect.addEventListener('change', handleChange);

    // 初期値の設定
    setTimeout(() => {
      updateCartAttributes(deliveryDateSelect.value, deliveryTimeslotSelect.value);
    }, 100);
  }

  // ドロワーの処理
  function initDrawer() {
    const deliveryDateSelect = document.querySelector('#drawer_delivery_date');
    const deliveryTimeslotSelect = document.querySelector('#drawer_delivery_timeslot');
    
    if (!deliveryDateSelect || !deliveryTimeslotSelect) {
      return;
    }

    // セレクトボックス変更時の処理
    function handleChange() {
      updateCartAttributes(deliveryDateSelect.value, deliveryTimeslotSelect.value);
    }

    deliveryDateSelect.addEventListener('change', handleChange);
    deliveryTimeslotSelect.addEventListener('change', handleChange);

    // 初期値の設定
    setTimeout(() => {
      updateCartAttributes(deliveryDateSelect.value, deliveryTimeslotSelect.value);
    }, 100);
  }

  // 初期化
  function init() {
    // カートページの初期化
    if (window.location.pathname === '/cart') {
      initCartPage();
    }

    // ドロワーの初期化 (常に実行)
    initDrawer();

    // ドロワーの動的読み込み対応
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('#drawer_delivery_date')) {
            initDrawer();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // DOM読み込み完了後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* =========================================================================
   ADV Custom: お知らせ全画面モーダル (announcement-modal セクション)
   - once (1ブラウザ1回)・遅延表示を自己完結で制御 (テーマ内部に非依存)
   - localStorage キーは独自 (newsletter-popup と衝突しない)
   ========================================================================= */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'adv:announcement:seen:';

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function storageKey(modal) {
    var version = modal.getAttribute('data-adv-version') || '';
    return STORAGE_PREFIX + version;
  }

  function hasSeen(modal) {
    try {
      return window.localStorage.getItem(storageKey(modal)) === 'true';
    } catch (e) {
      return false;
    }
  }

  function markSeen(modal) {
    try {
      window.localStorage.setItem(storageKey(modal), 'true');
    } catch (e) {
      /* localStorage 不可 (プライベートモード等)でも表示自体は成立させる */
    }
  }

  function openModal(modal) {
    if (modal.classList.contains('is-open')) return;
    // 1) 表示領域を確保 (display:block, opacity:0 の初期状態)
    modal.classList.add('is-open');
    document.body.classList.add('adv-modal-open');
    // 2) リフローを強制して初期状態を確定 → .is-visible でフェードインを発火
    //    (rAF に依存しないのでバックグラウンドタブ等でも確実にトランジションする)
    void modal.offsetWidth;
    modal.classList.add('is-visible');
    // テーマエディタのプレビュー中は once を記録しない (編集のたびに見られるように)
    if (!isDesignMode() && modal.getAttribute('data-adv-once') === 'true') {
      markSeen(modal);
    }
  }

  function closeModal(modal) {
    if (!modal.classList.contains('is-open')) return;
    // フェードアウト → 完了後に display:none
    modal.classList.remove('is-visible');
    document.body.classList.remove('adv-modal-open');
    var dialog = modal.querySelector('.adv-announcement-modal__dialog');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      modal.classList.remove('is-open');
    };
    if (dialog) {
      dialog.addEventListener('transitionend', finish, { once: true });
    }
    // transitionend が来ない場合のフォールバック
    setTimeout(finish, 500);
  }

  function scheduleModal(modal) {
    if (modal.dataset.advTimer) {
      clearTimeout(parseInt(modal.dataset.advTimer, 10));
    }
    var delay = parseInt(modal.getAttribute('data-adv-delay') || '0', 10) * 1000;
    var timer = setTimeout(function () {
      openModal(modal);
    }, delay);
    modal.dataset.advTimer = String(timer);
  }

  function bindModal(modal) {
    if (modal.dataset.advBound === '1') return;
    modal.dataset.advBound = '1';

    // 閉じる操作 (オーバーレイ／×ボタン)
    modal.querySelectorAll('[data-adv-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal(modal);
      });
    });

    // ESC で閉じる
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && modal.classList.contains('is-open')) {
        closeModal(modal);
      }
    });
  }

  function activateModal(modal) {
    bindModal(modal);

    // テーマエディタ内では once を無視して必ず表示 (プレビューのため)
    if (isDesignMode()) {
      openModal(modal);
      return;
    }

    var once = modal.getAttribute('data-adv-once') === 'true';
    if (once && hasSeen(modal)) return;

    scheduleModal(modal);
  }

  function initAnnouncementModals(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-adv-modal]').forEach(activateModal);
  }

  function run() {
    initAnnouncementModals(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // テーマエディタでセクションを再読込／選択した時に再評価
  document.addEventListener('shopify:section:load', function (e) {
    initAnnouncementModals(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var modal = e.target.querySelector('[data-adv-modal]');
    if (modal) openModal(modal);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var modal = e.target.querySelector('[data-adv-modal]');
    if (modal) closeModal(modal);
  });

})();